import * as React from 'react';
import { IGroupDividerProps, GroupHeader, IGroup } from '@fluentui/react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/types';
import { useCallback } from 'react';
import { setSchedulingExpandedGroups } from '../../redux/ui/actions';

export const ShiftMarketGroupHeader = (props: IGroupDividerProps) => {
  const ui = useSelector((state: RootState) => state.ui);

  const dispatch = useDispatch();

  const toggleCollapsed = useCallback(
    (group: IGroup) => {
      if (!group.isCollapsed) {
        dispatch(setSchedulingExpandedGroups(ui.schedulingExpand.filter((s) => s !== group.key)));
      } else {
        dispatch(setSchedulingExpandedGroups([group.key].concat(...ui.schedulingExpand)));
      }
    },
    [dispatch, ui]
  );

  return <GroupHeader {...props} onToggleCollapse={toggleCollapsed} />;
};
